import { render, staticRenderFns } from "./aboutTasks.vue?vue&type=template&id=0101359c&scoped=true&"
import script from "./aboutTasks.vue?vue&type=script&lang=js&"
export * from "./aboutTasks.vue?vue&type=script&lang=js&"
import style0 from "./aboutTasks.vue?vue&type=style&index=0&id=0101359c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0101359c",
  null
  
)

export default component.exports